<template>
  <div>
    <v-card class="fullForm">
      <div class="fullText">
        <h3>
          شرايط و مراحل ثبت درخواست دريافت اخذ حکم تلبس طلاب حوزه علميه خراسان:
        </h3>
        <br />
        <ol>
          <li>مطالعه دقيق آئين نامه اخذ حکم تلبس</li>
          <li>ثبت درخواست دریافت گواهی تلبس پس از تایید نکات</li>
          <li>منتظر تاييد حراست بمانيد.</li>
          <li>
            پس از تأييد، جهت شركت در كارگاه تلبس در مدرسه تبليغ، به آدرس زير مراجعه فرماييد.
            <br />
            <a href="https://tabliqkh.lms2.hozehkh.com/products/?categories=1731" target="_blank"
              >https://tabliqkh.lms2.hozehkh.com/products/?categories=1731</a
            >
          </li>
          <li>
            براي شركت در كارگاه تلبس از طريق سامانه طلوع >ساير > لينك‌هاي مفيد >
            سامانه آموزش مجازي مبلغان (مدرسه تبليغ) اقدام نماييد
          </li>
          <li>تاييد سيستمي توسط مدير مدرسه براي طلاب تحت برنامه</li>
          <li>
            دريافت حكم تلبس از طريق سامانه طلوع > گواهي تلبس> مشاهده سوابق
          </li>
        </ol>
        <br />
        <h4>بازه زمانی :</h4>
        <br />
        <v-data-table
          :headers="headers"
          :items="ranges"
          class="elevation-1 rounded ranges"
          :disable-pagination="true"
          :hide-default-footer="true"
          :hide-default-header="true"
        >
        </v-data-table>
        <br />
        <h4>نکات :</h4>
        <br />
        <ol>
          <li>
            در صورت عدم تأييد توسط مديريت حراست و صيانت، پس از يك هفته با مديريت
            مذكور جهت تأييد تماس بگيريد.
          </li>
          <li>
            طلاب ورودی های قبل از 1380 فقط نیاز به درخواست و تایید حراست دارند
            و نیازی به شرکت در کارگاه وآزمون نیست.
          </li>
          <li>
            در صورت عدم شركت يا قبول نشدن در كارگاه، ثبت درخواست مجدد ضروري است.
          </li>
        </ol>
      </div>

      <br />
      <br />

      <div style="width: 100%">
        <v-simple-checkbox
          v-model="showNext"
          :ripple="false"
        ></v-simple-checkbox>
        <b>موارد فوق را با دقت مطالعه كردم و نسبت به رعایت آن متعهد مي شوم.</b>
      </div>
    </v-card>
    <div class="confirm">
      <v-btn
        class="register"
        v-if="showNext"
        :class="!isMobile ? 'btnMargin' : ''"
        color="primary white--text"
        rounded
        @click="applyRequest"
        :disabled="apiRunning"
      >
        {{ apiRunning ? "لطفا منتظر بمانید..." : "ارسال درخواست" }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { requestTalabbos } from "@/api/talabbos";
export default {
  data() {
    return {
      showNext: false,
      showRequest: false,
      headers: [
        {
          text: "",
          align: "start",
          sortable: false,
          value: "text1",
        },
        {
          text: "",
          align: "start",
          sortable: false,
          value: "text2",
        },
      ],
      ranges: [
        {
          text1: "ثبت درخواست گواهی تلبس:",
          text2: "1 الی 15 هر ماه شمسی",
        },
        {
          text1: "تایید مدیریت حراست و صیانت حوزه علمیه خراسان:",
          text2: "1 هفته کاری",
        },
        {
          text1: "کارگاه های آموزش کاربردی تلبس:",
          text2: "16 الی 29 هر ماه شمسی ",
        },
        {
          text1: "آزمون حکم تلبس:",
          text2: "30 هر ماه شمسی",
        },
      ],
    };
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
  },
  created() {},

  methods: {
    closeDialog() {
      this.$store.commit("SET_DIALOG_SHOW", false);
    },

    applyRequest() {
      this.$store.commit("SET_API_RUNNING", true);
      requestTalabbos()
        .then((response) => {
          const data = response.data;
          this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
          this.$store.commit("SET_API_RUNNING", false);
          this.$router.push({ path: "/talabbos-index" });
        })

        .catch((error) => {
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
  },
  /**
   * user changed date
   */
};
</script>
<style scoped>
.v-card__title {
  border-radius: 15px !important;
}

.register2 {
  width: 300px !important;
  margin: 20px auto;
}
.v-text-field__details {
  display: none;
}

.v-simple-checkbox {
  top: -5px;
  position: relative;
  margin: 2px 0 0 5px;
  float: right;
}
.fullForm {
  margin-bottom: 65px;
}
</style>
<style>
.ranges .v-data-table__wrapper table tbody tr td:first-child {
  font-weight: bold;
}
.ranges .v-data-table__wrapper table {
  border: thin solid black !important;
}
</style>
